$cart = $(".js-cart");
$cartAmount = $(".js-cart_amount");

$cart.on("click", function(e){

})

function cartAmountAdd(number){
    if(hx.is_numeric(number)){
        $cartAmount.each(function(){
            var cartAmount = parseInt($(this).text())
            var newAmount = (cartAmount + parseInt(number));
            $(this).text(newAmount);

            let ariaLabelText = hx.replace(aria_label_warenkorb_text,'#anzahl#', newAmount);
            $cart.attr('aria-label', ariaLabelText);
        });
    }
}

function cartAmountSet(number){
    if(hx.is_numeric(number)){
        $cartAmount.text(parseInt(number));
    }
}